import { SkeletonComponent } from '@design-system';

export const BibliothequeSkeleton: React.FC = () => {
    return (
        <>
            {[...Array(8)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '80px',
                        marginTop: '12px',
                        borderRadius: '18px'
                    }}
                />
            ))}
        </>
    );
};
